// projectReducer.js

import { FETCH_PROJECTS_FAILURE, FETCH_PROJECTS_REQUEST, FETCH_PROJECTS_SUCCESS } from "../Actions/Actions";


const initialState = {
  isLoading: false,
  projects: [],
  error: null,
};

const projectReducer = (state = initialState,{type,payload}) => {
  switch (type) {
    case FETCH_PROJECTS_REQUEST:
      return { ...state, isLoading: true, error: null  };
    case FETCH_PROJECTS_SUCCESS:
      return { ...state, isLoading: false, projects: payload};
    case FETCH_PROJECTS_FAILURE:
      return { ...state, isLoading: false, error: payload };
    default:
      return state;
  }
};

export default projectReducer;
